module.exports = __webpack_public_path__ + "static/media/30x20.315034db.png";